import * as React from 'react'

const TeacherSignUpInfo = () => (
  <div className="info">
    <h2>More than 5,000 schools use Quill&#39;s free online tools to help their students become strong&nbsp;writers.</h2>
    <ul>
      <li>Quill provides free access to 700 writing and grammar&nbsp;activities</li>
      <li>Students receive immediate feedback on their&nbsp;work</li>
      <li>Teachers or guardians identify student needs and measure growth with diagnostics and&nbsp;reports</li>
    </ul>
  </div>
)

export default TeacherSignUpInfo
